import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export function ProtectedRoute({ children, requiredRole = null, requiredPermission = null }) {
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    const sessionToken = localStorage.getItem('session_token');
    const userRole = localStorage.getItem('user_role');
    const userId = localStorage.getItem('user_id');

    if (!sessionToken || !userRole || !userId) {
      setIsAllowed(false);
      return;
    }

    if (requiredRole && userRole !== requiredRole) {
      setIsAllowed(false);
      return;
    }

    if (!requiredPermission || userRole === 'admin') {
      setIsAllowed(true);
      return;
    }

    const checkPermission = async () => {
      try {
        const response = await fetch(
          `/api/users/${userId}/has-permission/${encodeURIComponent(requiredPermission)}`,
          {
            headers: {
              'X-Session-Token': sessionToken,
            },
          }
        );

        if (!response.ok) {
          setIsAllowed(false);
          return;
        }

        const data = await response.json();
        setIsAllowed(data.success && data.hasPermission === true);
      } catch (error) {
        console.error('Permission check failed:', error);
        setIsAllowed(false);
      }
    };

    checkPermission();
  }, [requiredRole, requiredPermission]);

  if (isAllowed === null) {
    return <div className="text-center p-5">Loading...</div>;
  }

  if (!isAllowed) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
